'use strict';

module.exports = function(s) {
  return s.substr(0, 1).toUpperCase() + s.substring(1);
};




//////////////////
// WEBPACK FOOTER
// ./~/ucfirst/ucfirst.js
// module id = 486
// module chunks = 0 1 2 3 4